import * as React from 'react'

import { Strong } from 'main/ui'
// import { moreInformationHref } from './constants'
import { Container, LeftContainerContainer } from './DesktopView.styles'
import EditButton from './EditButton'

interface IProps {
  onRequestEdit: () => void
}

export default function DesktopView(props: IProps) {
  const { onRequestEdit } = props

  return (
    <Container>
      <LeftContainerContainer>
        <div>
          <Strong>Would you like to edit your website?</Strong>
        </div>
        {/* TODO (aboltunov): unhide when we have a url to link to */}
        {/* <div>
          <MoreInformationNativeLink href={moreInformationHref}>
            More information
          </MoreInformationNativeLink>
        </div> */}
      </LeftContainerContainer>
      <EditButton onClick={onRequestEdit} />
    </Container>
  )
}
